module.exports = __webpack_public_path__ + "static/media/tiktok-icon.944a7ac4.png";